<template>
  <div class="layout-box">
    <LayoutHeader headtitle="撮合分析"></LayoutHeader>
<!--    <iframe scrolling="no" :src="Urls"></iframe>-->
    <div class="secondary-content">
      <div class="matching-l">
        <div class="shell">
          <h3 style="padding-top: 12px">PTA&MEG按月成交额</h3>
          <div id="machartbar" style="height: 256px; width: 100%; margin-top: 10px"></div>
          <h3 style="margin-top: 40px">PTA&MEG按月成交量</h3>
          <div id="machartline" style="height: 256px; width: 100%"></div>
        </div>
      </div>
      <div class="matching-c">
        <div class="matching-c-top">
          <div :class="matchingdata.dealOfMeg.diffPrice<0?'fall':''"><h3>MEG</h3><p><span><b>{{ Math.round(matchingdata.dealOfMeg.latestPrice||0) }}</b></span><span><i style="margin-top: 6px">{{ Math.round(matchingdata.dealOfMeg.diffPrice||0) }}</i><i>{{ parseFloat((matchingdata.dealOfMeg.diffPercent||0).toFixed(2)) }}%</i></span></p></div>
          <div :class="matchingdata.dealOfPta.diffPrice<0?'fall':''"><h3>PTA</h3><p><span><b>{{ Math.round(matchingdata.dealOfPta.latestPrice||0) }}</b></span><span><i style="margin-top: 6px">{{ Math.round(matchingdata.dealOfPta.diffPrice||0) }}</i><i>{{ parseFloat((matchingdata.dealOfPta.diffPercent||0).toFixed(2)) }}%</i></span></p></div>
        </div>
        <div class="matching-c-list">
          <div style="padding-left: 46px"><p>{{matchingdata.dealOfWeek.dealNum || '--'}}<em>单</em></p><h3>本周交易</h3></div>
          <div><p>{{matchingdata.dealOfWeek.dealQty || '--'}}<em>吨</em></p><h3>成交数量</h3></div>
          <!-- <div><p>{{ Math.round((matchingdata.dealOfWeek.dealPriceTotal/10000)||0)  || '--'}}<em>万元</em></p><h3>成交金额</h3></div> -->
          <div><p>1.82<em>亿元</em></p><h3>成交金额</h3></div>
        </div>
        <div class="matching-c-list">
          <div style="padding-left: 46px"><p>{{ Math.round(matchingdata.dealOfWeek.dealPriceAvg||0)  || '--'}}<em>元/吨</em></p><h3>成交均价</h3></div>
          <div><p>{{ matchingdata.dealOfMonth.dealQty  || '--' }}<em>吨</em></p><h3>本月合计</h3></div>
          <div><p>{{ matchingdata.dealOfYear.dealNum || '--' }}<em>单</em></p><h3>本年合计</h3></div>
        </div>
      </div>
      <div class="matching-r">
        <div class="shell">
          <h3>即时撮合成交</h3>
          <div class="clinch-deal-list">
            <p><span>序号</span><span>产品</span><span>成交价/元</span><span>成交量/吨</span><span>时间</span></p>
            <ul>
              <vue-seamless-scroll :data="clientlist" :class-option="classOption" class="seamless-warp">
                <li v-for="(item,index) in clientlist" :key="index"><span>{{ index+1 }}</span><span>{{ item.product }}</span><span>{{ item.unitPrice }}</span><span>{{ item.quantity }}</span><span>{{ item.time }}</span></li>
              </vue-seamless-scroll>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import {getTime} from "../../bll/utils";

export default {
  name: 'MatchingAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  data () {
    return {
      clientlist: [],
      matchingdata:{
        dealOfWeek: {dealNum:null,dealQty:null},
        dealOfMonth: {dealQty:null},
        dealOfYear: {dealNum:null},
        dealOfMeg: {diffPercent:0,diffPrice:0,latestPrice:0},
        dealOfPta: {diffPercent:0,diffPrice:0,latestPrice:0}
      }
      // Urls:'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=d2800d18-63b2-4f18-a68a-a9c843ffa564&accessToken=97f5ca28a662be4c872c1143ecf82903&dd_orientation=auto'
    }
  },
  computed:{
    classOption(){
      return{
        step:0.2,// 数值越大速度滚动越快
        limitMoveNum:2,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop:true,// 是否开启鼠标悬停stop
        direction:1,// 0向下 1向上 2向左 3向右
        openWatch:true,// 开启数据实时监控刷新dom
        singleHeight:0,// 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0,// 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime:1000,// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted () {
    let $this = this
    $this.dataRefresh.$ons('Refresh', () => {
      // let tt = getTime('start')
      // $this.Urls = $this.Urls + '&tt=' + tt
      $this.getdata()
    })
    setTimeout(function () {
      $this.drawbarchart()
      $this.getdata()
    },500)
  },
  methods:{
    getdata(){
      const url = '/api-portal/ccf/orderMatching/getData';
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          this.matchingdata=datas.data
        }
      })
      const url2 = '/api-portal/ccf/orderMatching/getListData';
      this.$api.post(url2, {pageNum:1,pageSize:300}, (response) => {
        let datas=response.data||''
        if(datas&&datas.code=='000000'){
          this.clientlist=datas.data.records
        }
      },'json')
      const url3 = '/api-portal/ccf/orderMatching/getVolumeData';
      this.$api.post(url3, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          datas.map(val=>{
            const time=val.time
            if(datatime.indexOf(time)<0){
              datatime.push(time)
            }
          })
          const datapta= new Array(datatime.length).fill('')
          const datameg= new Array(datatime.length).fill('')
          datas.map(val=>{
            const product=val.product
            const unitPrice=(val.unitPrice/100000000).toFixed(2)
            const time=val.time
            const indexs=datatime.indexOf(time)
            if(indexs>=0){
              product=='MEG'?datameg.splice(indexs, 1, unitPrice):datapta.splice(indexs, 1, unitPrice)
            }
          })
          this.drawbarchart(datatime,datapta,datameg)
        }
      })
      const url4 = '/api-portal/ccf/orderMatching/getTurnoverData';
      this.$api.post(url4, {}, (response) => {
        let datas=response.data.data||''
        if(datas){
          let datatime=[]
          datas.map(val=>{
            const time=val.time
            if(datatime.indexOf(time)<0){
              datatime.push(time)
            }
          })
          const datapta= new Array(datatime.length).fill('')
          const datameg= new Array(datatime.length).fill('')
          datas.map(val=>{
            const product=val.product
            const quantity=(val.quantity/10000).toFixed(2)
            const time=val.time
            const indexs=datatime.indexOf(time)
            if(indexs>=0){
              product=='MEG'?datameg.splice(indexs, 1, quantity):datapta.splice(indexs, 1, quantity)
            }
          })
          this.drawlinediagram(datatime,datapta,datameg)
        }
      })
    },
    drawbarchart (time,data1,data2) {
      const myEchartst = this.$echarts.init(document.getElementById('machartbar'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} 亿`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: [{
          type: 'value',
          name:'MEG',
          // min:val=>{
          //   return Math.ceil(val.min)
          // },
          nameTextStyle:{
            color: '#C1D3F4'
          },
          splitLine:{
            show:false
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return params+'亿'
            }
          }
        },{
          type: 'value',
          name:'PTA',
          // min:val=>{
          //   return Math.ceil(val.min)
          // },
          nameTextStyle:{
            color: '#C1D3F4'
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return params+'亿'
            }
          }
        }],
        series: [
          {
            name: 'PTA',
            type: 'bar',
            data: data1,
            yAxisIndex:1,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#00D900'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#00D900'
                  }, {
                    offset: 1,
                    color: '#10A1BD'
                  }
                ]
              }
            }
          },
          {
            name: 'MEG',
            type: 'bar',
            data: data2,
            yAxisIndex:0,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#F2C61A'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#F2C61A'
                  }, {
                    offset: 1,
                    color: '#8F41E9'
                  }
                ]
              }
            }
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    },
    drawlinediagram (data1,data2,data3) {
      const myEchartst = this.$echarts.init(document.getElementById('machartline'))
      let option = {

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} 万`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return params+'万'
            }
          }
        },
        series: [
          {
            name: 'PTA',
            type: 'line',
            smooth: true,
            data: data2,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#0DAC97'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            lineStyle: {
              color: '#0DAC97'
            },
            color: '#0DAC97'
          },{
            name: 'MEG',
            type: 'line',
            smooth: true,
            data: data3,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#FCCF1B'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            lineStyle: {
              color: '#FDDD60'
            },
            color: '#FCCF1B'
          }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../assets/secondary/bg-1.jpg");
  /*filter:contrast(120%) brightness(120%) hue-rotate(358deg) saturate(90%); !*对比度 亮度 色相旋转 饱和度*!*/
}

.secondary-content{
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.matching-l{
  width: 405px;
  height: 777px;
  margin-right: -50px;
  background: url("../../assets/secondary/border-2l.png") no-repeat center/100%;
}

.matching-c{
  width: 1075px;
  height: 724px;
  background: url("../../assets/secondary/matching.png") no-repeat center/100%;
  margin-top: 170px;
}

.matching-r{
  width: 405px;
  height: 777px;
  margin-left: -40px;
  background: url("../../assets/secondary/border-2r.png") no-repeat center/100%;
}

.shell{
  width: 380px;
  height: 648px;
  margin-left: 2px;
  color: #fff;
  margin-right: 15px;
  margin-top: 98px;
  transform:perspective(25em) rotatey(-6deg);
}

.shell h3{
  padding-top: 12px;
  padding-left: 6px;
  color: #BED1F8;
}

.matching-l .shell{
  margin-left: 20px;
  margin-right: 13px;
  height: 658px;
  transform:perspective(2.1em) rotatey(0.55deg);
}

.matching-c-top{
  display: flex;
  padding: 0 10%;
  box-sizing: border-box;
  margin-top: 65px;
  margin-bottom: 45px;
  justify-content: space-around;
  align-items: center;
  color: #fff;
}

.matching-c-top>div{
  width: 205px;
  height: 141px;
  padding: 21px 18px;
  box-sizing: border-box;
  border-radius: 5px;
  background: url("../../assets/secondary/bg-2.png") no-repeat center/100%;
}

.matching-c-top h3{
  font-size: 30px;
  font-weight: normal;
  text-shadow: 4px 3px 5px rgba(0,0,0,.3);
  margin-bottom: 15px;
  font-family: 'fzskjt';
}

.matching-c-top p{
  display: flex;
  justify-content: space-between;
}

.matching-c-top b{
  font-size: 46px;
  font-family: Bahnschrift;
  text-shadow: 4px 3px 7px rgba(0,0,0,.4);
}

.matching-c-top i{
  display: block;
  font-style: normal;
  font-family: Bahnschrift;
  font-size: 17px;
  text-align: right;
  text-shadow: 1px 2px 2px rgba(0,0,0,.4);
}

.matching-c-list{
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  color: #fff;
}

.matching-c-list>div{
  width: 240px;
  height: 146px;
  padding: 30px 20px;
  box-sizing: border-box;
  /*background: rgba(12,15,35,.5);*/
}

.matching-c-list p{
  font-size: 48px;
  font-weight: bold;
  font-family: Bahnschrift;
  text-shadow: 4px 3px 7px rgba(0,0,0,.4);
}

.matching-c-list em{
  font-size: 20px;
  font-style: normal;
  margin-left: 12px;
  font-weight: normal;
}

.matching-c-list h3{
  font-family: 'fzskjt';
  font-size: 24px;
  font-weight: normal;
}

div.fall{
  background: url("../../assets/secondary/bg-3.png") no-repeat center/100%;
}

.clinch-deal-list{
  padding: 10px 12px;
  background: rgba(25,12,34,0.4);
  font-size: 14px;
}

.clinch-deal-list p,.clinch-deal-list li{
  display: flex;
  justify-content: space-between;
}

.clinch-deal-list p{
  border-bottom: 1px solid #1E60B9;
  padding-bottom: 8px;
}

.clinch-deal-list li{
  height: 32px;
  line-height: 32px;
  font-size: 12px;
}

.clinch-deal-list li:nth-child(even){
  background: rgba(65,82,233,0.6);
}

.clinch-deal-list ul{
  height: 565px;
  overflow: hidden;
}

.clinch-deal-list span{
  text-align: left;
  display: inline-block;
  flex: 1;
}

.clinch-deal-list span:first-child{
  width: 40px;
  flex: none;
  text-align: center;
}

.clinch-deal-list span:nth-child(1){
  width: 80px;
}

.clinch-deal-list span:nth-child(2){
  width: 80px;
}

.clinch-deal-list span:nth-child(3){
  width: 80px;
}

iframe{
  width: 100%;
  height: calc(100% - 122px);
  padding-top: 120px;
  border: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/matching-analysis.vue